"use strict";
import { WagmiProvider } from "wagmi";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { ConnectionProvider } from "hooks/useConnect";
import { useWalletCapabilitiesStateEffect } from "state/walletCapabilities/hooks/useWalletCapabilitiesStateEffect";
export function createWeb3Provider(params) {
  const { wagmiConfig, reconnectOnMount = true, includeCapabilitiesEffects = true } = params;
  const WalletCapabilitiesEffects = () => {
    useWalletCapabilitiesStateEffect();
    return null;
  };
  const Provider = ({ children }) => <WagmiProvider config={wagmiConfig} reconnectOnMount={reconnectOnMount}>
      <RainbowKitProvider>
        {
    /* ensure RainbowKit context for transaction hooks */
  }
        <ConnectionProvider>
          {includeCapabilitiesEffects && <WalletCapabilitiesEffects />}
          {children}
        </ConnectionProvider>
      </RainbowKitProvider>
    </WagmiProvider>;
  Provider.displayName = "Web3Provider";
  return Provider;
}
